import { Injectable } from '@angular/core';

import { NgProgress } from 'ngx-progressbar';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {

  allRequests: any = [];

  constructor(
    private progressRef:NgProgress
  ) { }

  assignAllrequests(url) {
    this.allRequests.push(url);
    this.progressRef?.ref().start();
  }

  removeUrlOnresponse(url) {
    const index = this.allRequests.indexOf(url);
    if (index > -1) {
      this.allRequests.splice(index, 1);
    }

    if (this.allRequests.length === 0) {
      this.progressRef?.ref().complete();
    }
  }

  checkForDuplicateUrl(url) {
    const index = this.allRequests.indexOf(url);
    if (index > -1) {
     return false;
    } else {
      return true;
    }
  }
}
